'use strict';

var Backbone = require('dibs-backbone');

var GlobalContextBaseView = Backbone.BaseView.extend({
    constructor: function(options, parentView) {
        options = options || {};
        this.context = options.context;
        if (!this.context) {
            throw new Error('No context was provided to GlobalContextBaseView');
        }

        return Backbone.BaseView.call(this, options, parentView);
    },
    getContext: function() {
        return this.context;
    },
});

module.exports = GlobalContextBaseView;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/reactHelpers/GlobalContextBaseView.js
// module id = 139
// module chunks = 7 8 10 11 13 23 26 27 31